const menus =  [
  {
    name: '公司概况',
    id: "001",
    nameEn: "About",
    children: [
      { name: '公司简介', id: "001001", listType: "info" },
      { name: '领导致辞', id: "001002", listType: "info" },
      { name: '管理团队', id: "001003", listType: "info" },
      { name: '组织机构', id: "001004", listType: "info" },
      { name: '部门职责', id: "001007", listType: "info" },
      { name: '企业荣誉', id: "001005", listType: "img" },
      { name: '重点项目', id: "001006", listType: "img" }
    ]
  },
  {
    name: '新闻中心',
    id: "002",
    nameEn: "News",
    children: [
      { name: '企业要闻', id: "002001" },
      { name: '视频宣传', id: "002005", nameEn: "Video", listType: "img" },
      { name: '工作动态', id: "002004" },
      { name: '图片新闻', id: "002002", listType: "img" },
      { name: '主题教育', id: "002007" }
    ]
  },
  {
    name: '项目风采',
    id: "003",
    nameEn: "Style",
    children: [
      { name: '项目风采', id: "003001", listType: "img" },
    ]
  },
  {
    name: '运营管理',
    id: "004",
    nameEn: "Service",
    children: [
      { name: '会展动态', id: "004001" },
      { name: '体育文化', id: "004002" },
      { name: '物业服务', id: "004003" },
      { name: '酒店管理', id: "004004" },
      { name: '公共服务', id: "004006" },
      { name: '资产管理', id: "004007" },
      { name: '文旅研学', id: "004008" },
      { name: '百姓平台', id: "004009" }
    ]
  },
  {
    name: '党风廉政',
    id: "005",
    nameEn: "Party",
    children: [
      { name: '党团建设', id: "005001" },
      { name: '纪检监督', id: "005002" },
      { name: '投诉举报', id: "005003", listType: "info" },
      { name: '脱贫攻坚', id: "005006" },
      { name: '党章党规', id: "005008" }
    ]
  },
  {
    name: '企业文化',
    id: "006",
    nameEn: "Culture",
    children: [
      { name: '企业标识', id: "006001", listType: "info" },
      { name: '普法宣传', id: "006006" },
      { name: '企业文化', id: "006002" },
      { name: '工作简报', id: "006005" },
      { name: '健康科普', id: "006007" },
      { name: '媒体聚焦', id: "006008", nameEn: "Focus" }
    ]
  },
  {
    name: '安全生产',
    id: "010",
    nameEn: "Safety",
    children: [
      { name: '安全生产', id: "010001" },
      { name: '学习园地', id: "010002" }
    ]
  },
  {
    name: '招标投标',
    id: "011",
    // nameEn: "Bid",
    nameEn: "About",
    children: [
      { name: '招标公告', id: "011001", listType: "form" },
      { name: '答疑变更', id: "011002", listType: "form" },
      { name: '中标候选人公告', id: "011004", listType: "form" },
      { name: '中标结果公告', id: "011003", listType: "form" }
    ]
  },
  {
    name: '信息发布',
    id: "008",
    nameEn: "Contact",
    children: [
      { name: '通知公告', id: "008002", nameEn: "Notice", listType: "form" },
      { name: '人才招聘', id: "008001", listType: "form" },
      { name: '信息披露', id: "008004", listType: "form" }
    ]
  },

  {
    name: '新闻搜索',
    id: "local001",
    nameEn: "Search",
    meta: {
      hidden: true
    },
    children: [
      { name: '搜索结果', id: "local001001" }
    ]
  },
]

export function getMenuById(id) {
  let menu = null
  menus.find(item => {
    if (item.id === id) {
      menu = item
    } else if (item.children) {
      item.children.find(child => {
        if (child.id === id) {
          menu = child
          return true
        }
      })
    }
    if(menu) {
      return true
    }
  })
  return menu
}
export function getMenuByName(name) {
  let menu = null
  menus.find(item => {
    if (item.name === name) {
      menu = item
    } else if (item.children) {
      item.children.find(child => {
        if (child.name === name) {
          menu = child
          return true
        }
      })
    }
    if(menu) {
      return true
    }
  })
  return menu
}
export function getMenuListTypeById(id) {
  return getMenuById(id)?.listType
}
export default menus